<template>
    <div>
        <div v-if="method === 'authorize'">
            <refill-authorize />
        </div>
        <div v-if="method === 'authorizeHosted'">
            <refill-authorize-hosted />
        </div>
        <div v-if="method === 'crypto'">
            <refill-crypto />
        </div>
        <div v-if="method === 'usdc'">
            <refill-usdc />
        </div>
        <div v-if="method === 'btc'">
            <refill-bitcoin />
        </div>
        <div v-if="method === 'cardOnramp'">
            <refill-card-onramp />
        </div>
        <div v-if="method === 'paypal'">
            <refill-paypal />
        </div>
        <div v-if="method === 'paygate'">
            <refill-paygate />
        </div>

        <div v-if="!method">
            <h5 class="text-center mt-3">
                {{ $t("Select Payment Method") }}
            </h5>

            <b-btn
                v-for="pm in paymentMethods"
                :key="pm.type"
                @click="setMethod(pm.type)"
                variant="light"
                block
                size="lg"
                class="mt-3 d-flex align-items-center justify-content-between btn-brand"
                :class="{ 'payment-method-recommended': pm.recommended }"
            >
                <div class="d-flex align-items-center text-left">
                    <font-awesome-icon
                        :icon="pm.icon"
                        class="text-primary mr-3"
                        size="lg"
                    />
                    <div>
                        <h5 class="mb-0">
                            {{ pm.title }}
                        </h5>
                        <div class="small text-secondary">
                            {{ pm.subtitle }}
                        </div>
                    </div>
                </div>
                <font-awesome-icon icon="fa-light fa-chevron-right" />
            </b-btn>

            <refill-credit-explainer class="mt-4" />
        </div>
    </div>
</template>

<style scoped>
.payment-method-recommended {
    border: 2px solid #f4a261;
    box-shadow: 0 0 0 0 rgba(244, 162, 97, 0.6);
    animation: recommended-pulse 2.4s ease-out infinite;
    position: relative;
}

@keyframes recommended-pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(244, 162, 97, 0.55);
    }
    70% {
        box-shadow: 0 0 0 12px rgba(244, 162, 97, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(244, 162, 97, 0);
    }
}

</style>

<script>
import { mapState } from "vuex";

import RefillAuthorize from "@/components/wallet/refill/RefillAuthorize";
import RefillAuthorizeHosted from "@/components/wallet/refill/RefillAuthorizeHosted";
import RefillCrypto from "@/components/wallet/refill/RefillCrypto";
import RefillUsdc from "@/components/wallet/refill/RefillUsdc";
import RefillBitcoin from "@/components/wallet/refill/RefillBitcoin";
import RefillCardOnramp from "@/components/wallet/refill/RefillCardOnramp";
import RefillPaypal from "@/components/wallet/refill/RefillPaypal";
import RefillPaygate from "@/components/wallet/refill/RefillPaygate";
import RefillCreditExplainer from "@/components/wallet/refill/RefillCreditExplainer";

export default {
    created() {
        this.$store.dispatch("paymentMethods/refresh");
    },
    computed: {
        ...mapState("wallet", ["method"]),
        ...mapState("paymentMethods", {
            paymentMethods: "methods",
        }),
    },
    methods: {
        setMethod(method) {
            this.$store.commit("wallet/setMethod", method);
        },
    },
    components: {
        RefillCreditExplainer,
        RefillCrypto,
        RefillUsdc,
        RefillBitcoin,
        RefillCardOnramp,
        RefillPaypal,
        RefillPaygate,
        RefillAuthorize,
        RefillAuthorizeHosted,
    },
};
</script>